<template>
  <v-col
    cols="12"
    sm="6"
    md="12"
    class="code-type-group">
    <validation-provider
      v-slot="{ errors }"
      name="ประเภทโค้ดส่วนลด"
      :rules="action === 'generateNewCode' ? 'required' : ''">
      <v-radio-group
        v-model="codeType"
        :readonly="!editable"
        @change="bindValue">
        <v-radio
          label="สุ่มโค้ดต่อคน"
          class="ma-0 code-label"
          value="randomPerTel" />
        <v-radio
          value="fixedCode"
          class="my-0 code-label">
          <template v-slot:label>
            <div class="text-subtitle">
              กำหนดโค้ด
            </div>
            <div>
              <v-text-field
                v-model="code"
                :disabled="codeType !== 'fixedCode'"
                :readonly="!editable"
                class="ml-4 code-field"
                @input="bindValue" />
            </div>
            <v-btn
              color="primary"
              text
              class="ml-2"
              :disabled="!editable"
              @click="randomPromoCode">
              สุ่มโค้ด
            </v-btn>
          </template>
        </v-radio>
        <p class="red--text text-caption">
          {{ errors[0] }}
        </p>
      </v-radio-group>
    </validation-provider>
  </v-col>
</template>

<script>
  export default {
    props: {
      oldCode: {
        type: String,
        default: ''
      },
      oldCodeType: {
        type: String,
        default: ''
      },
      editable: {
        type: Boolean,
        default: false
      },
      action: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        codeType: '',
        code: '',
        countRandom: ''
      }
    },
    watch: {
      oldCode: {
        handler (val) {
          this.code = val
        }
      },
      oldCodeType: {
        handler (val) {
          this.codeType = val
        }
      }
    },
    mounted () {
      this.code = this.oldCode
      this.codeType = this.initCodeType()
      this.bindValue()
    },
    methods: {
      initCodeType () {
        return this.oldCode !== '' ? 'fixedCode' : 'randomPerTel'
      },
      bindValue () {
        this.$emit('input', {
          code: {
            value: this.code,
            enable: true
          },
          codeType: {
            value: this.codeType,
            enable: true
          }
        })
      },
      randomPromoCode () {
        this.code = this.randomForm(6, false)
        this.bindValue()
      },
      randomForm (length, digitsOnly) {
        let result = ''
        const alphaNum = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
        const digits = '0123456789'
        const format = digitsOnly ? digits : alphaNum

        for (let i = 0; i < length; i++) {
          result += format.charAt(Math.floor(Math.random() * format.length))
        }

        return result
      }
    }
  }
</script>

<style>
.code-type-group {
  height: 130px;
}
.code-field .v-text-field__slot > input{
  text-align: center;
}

.code-label {
  height: 40px;
}
</style>
